import { useContext } from 'react';
import { ExpenseDetailContext } from './ExpenseDetailContext';

export const useExpenseDetailContext = () => useContext(ExpenseDetailContext);
